import { cookies } from 'lib/enums';
import Backbone from 'backbone';
import jsCookie from 'js-cookie';
function shouldInitialize() {
	const { isLocalUser } = window.dataLayer;
	return isLocalUser;
}
const UsernapView = Backbone.View.extend({
	initialize: function() {
		window.onUsersnapCXLoad = function(api) {
			api.on('open', function(event) {
				// Populate email field from cookie
				let username = jsCookie.get(cookies.EMPLOYEE_USER_NAME);
				if (username) {
					event.api.setValue('visitor', `${username}@ferguson.com`);
				}
			});
			api.init({});
			window.Usersnap = api;
		};
		this._writeScript();
	},
	_writeScript: function() {
		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://widget.usersnap.com/load/3e5b711c-d3ca-46f5-8283-987d9430ce12?onload=onUsersnapCXLoad';
		document.getElementsByTagName('head')[0].appendChild(script);
	}
});

export function initializeUserSnapView() {
	if (shouldInitialize()) {
		return new UsernapView();
	}
}
